// src/components/SplashScreen.jsx
import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import animationData from "../assets/loader-logo.json";

const SplashScreen = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // 300ms fade-out after 2s
    const timer = setTimeout(() => setVisible(false), 1700);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`fixed top-0 left-0 w-full h-full bg-[#7366fc] z-[9999] flex items-center justify-center transition-opacity duration-500 ${
        visible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <Lottie
        animationData={animationData}
        loop={true}
        style={{ width: 200, height: 200 }}
      />
    </div>
  );
};

export default SplashScreen;
